import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  it: {
    "nav.experiences": "Esperienze",
    "nav.shop": "Shop",
    "nav.tomorrow": "Cosa fare domani",
    "nav.lastminute": "Last Minute",
    "nav.transfers": "Transfer",
    "nav.eat": "Dove Mangiare",
    "nav.guides": "Guide",
    "nav.partner": "Diventa Partner",
    "nav.concierge": "Chiedi a Cristalda",
    "nav.login": "Accedi",
    "nav.account": "Il mio account",
    "nav.admin": "Gestione",
    "nav.operator": "Operatore",
    "nav.store": "Store Mode",
    "nav.logout": "Esci",
    "hero.tagline": "Non venire solo a vedere. Vivilo.",
    "hero.subtitle": "Esperienze che vale la pena raccontare. Dal mare alle montagne.",
    "hero.question": "Sei venuto fin qui per stare in hotel? Speriamo di no.",
    "search.date": "Data",
    "search.people": "Persone",
    "search.category": "Categoria",
    "search.all": "Tutte le categorie",
    "search.cta": "Scopri le esperienze",
    "home.categories": "Cosa vuoi fare?",
    "home.tomorrow": "Cosa puoi fare domani a Vieste",
    "home.tomorrow.sub": "Esperienze con disponibilità per domani",
    "home.featured": "Esperienze in evidenza",
    "home.lastminute": "Last Minute Vieste",
    "home.lastminute.sub": "Ultimi posti disponibili, approfittane ora",
    "home.guides": "Guide & Ispirazione",
    "exp.book": "Prenota ora",
    "exp.from": "da",
    "exp.perperson": "a persona",
    "exp.perboat": "a barca",
    "exp.pervehicle": "a veicolo",
    "exp.pergroup": "a gruppo",
    "exp.fixed": "prezzo fisso",
    "exp.duration": "Durata",
    "exp.included": "Cosa è incluso",
    "exp.excluded": "Non incluso",
    "exp.meeting": "Punto di ritrovo",
    "exp.cancellation": "Politica di cancellazione",
    "exp.weather": "Politica meteo",
    "exp.reviews": "Recensioni",
    "exp.related": "Potrebbe piacerti anche",
    "exp.operator": "Operatore",
    "exp.selectdate": "Seleziona la data",
    "exp.selecttime": "Seleziona l'orario",
    "exp.participants": "Partecipanti",
    "exp.available": "Disponibile",
    "exp.few": "Ultimi posti",
    "exp.full": "Esaurito",
    "exp.addcart": "Aggiungi alla vacanza",
    "cart.title": "La tua vacanza a Vieste",
    "cart.empty": "La tua vacanza è vuota. Aggiungi esperienze!",
    "cart.total": "Totale",
    "cart.checkout": "Vai al checkout",
    "cart.remove": "Rimuovi",
    "checkout.title": "Completa la prenotazione",
    "checkout.details": "I tuoi dati",
    "checkout.name": "Nome",
    "checkout.surname": "Cognome",
    "checkout.email": "Email",
    "checkout.phone": "Telefono",
    "checkout.country": "Paese",
    "checkout.consent": "Acconsento a ricevere comunicazioni marketing",
    "checkout.pay": "Vai al pagamento",
    "checkout.payment": "Metodo di pagamento",
    "checkout.mock": "Pagamento sicuro con carta",
    "voucher.title": "Prenotazione confermata!",
    "voucher.number": "Numero prenotazione",
    "voucher.download": "Scarica voucher",
    "common.loading": "Caricamento...",
    "common.sponsored": "Sponsorizzato",
    "common.new": "Novità",
    "common.viewall": "Vedi tutte",
    "common.back": "Indietro",
    "concierge.title": "Chiedilo a Cristalda.",
    "concierge.sub": "Dicci cosa ti piace, quanto tempo hai e con chi sei. Al resto pensiamo noi.",
    "concierge.placeholder": "Es: Siamo una famiglia di 4 con bambini di 6 e 10 anni, restiamo 3 giorni. Cosa facciamo?",
    "concierge.ask": "Crea il mio itinerario",
    "whatsapp.help": "Hai bisogno di aiuto? Scrivici.",
    "cookie.msg": "Usiamo cookie tecnici essenziali e, con il tuo consenso, cookie di analisi e marketing per migliorare la tua esperienza.",
    "cookie.accept": "Accetta tutti",
    "cookie.essential": "Solo essenziali",
    "cookie.more": "Cookie Policy",
    "notfound.title": "Pagina non trovata",
    "notfound.sub": "La pagina che stai cercando non esiste o è stata spostata.",
    "notfound.home": "Torna alla home",
    "notfound.experiences": "Scopri le esperienze",
    "reg.accept.terms": "Accetto i Termini & Condizioni",
    "reg.accept.privacy": "Ho letto la Privacy Policy",
    "reg.accept.required": "Per registrarti devi accettare i Termini e la Privacy Policy.",
    "common.results": "risultati", "common.participants": "partecipanti",
    "exp.list.eyebrow": "Cristalda Experience · Gargano", "exp.list.all": "Tutte le esperienze",
    "exp.none": "Nessuna esperienza trovata.", "exp.viewall": "Vedi tutte le esperienze",
    "sort.recommended": "Consigliati", "sort.rating": "Migliori recensioni",
    "sort.priceasc": "Prezzo crescente", "sort.pricedesc": "Prezzo decrescente",
    "exp.maxparticipants": "Max partecipanti", "exp.minage": "Età minima", "exp.years": "anni",
    "toast.selectdatetime": "Seleziona data e orario", "toast.added": "Aggiunto alla tua vacanza a Vieste!",
    "exp.prelaunchdefault": "Prenotazioni prossimamente",
    "cart.builder": "Vacation Builder", "cart.addanother": "Aggiungi un'altra esperienza",
    "cart.summary": "Riepilogo", "cart.experiences": "Esperienze", "cart.days": "Giorni",
    "checkout.yourholiday": "La tua vacanza",
    "checkout.norealpayment": "Verrai reindirizzato al pagamento protetto",
    "checkout.gdpr": "I tuoi dati sono trattati secondo i principi GDPR.",
    "checkout.bookingerror": "Errore durante la prenotazione",
    "payment.processing": "Verifica del pagamento in corso...",
    "payment.wait": "Attendi qualche istante, non chiudere questa pagina.",
    "payment.success": "Pagamento riuscito!",
    "payment.successdesc": "Stiamo preparando il tuo voucher...",
    "payment.cancelled": "Pagamento annullato",
    "payment.cancelleddesc": "Nessun addebito è stato effettuato. La tua selezione è ancora nel carrello.",
    "payment.backtocart": "Torna al carrello",
    "payment.failed": "Pagamento non riuscito",
    "payment.faileddesc": "Non è stato possibile confermare il pagamento. Riprova o contattaci.",
    "payment.retry": "Riprova",
    "voucher.showqr": "Mostra questo QR al punto di ritrovo",
    "footer.legal": "Legale", "footer.terms": "Termini & Condizioni", "footer.guidesblog": "Guide & Blog", "footer.marketplace": "Marketplace turistico",
    "exp.lastspot": "Ultimo posto disponibile", "exp.spotsleftpre": "Ultimi", "exp.spotsleftpost": "posti disponibili", "toast.availchanged": "Disponibilità cambiata, riprova.", "common.error": "Si è verificato un errore. Riprova.",
  },
  en: {
    "nav.experiences": "Experiences", "nav.shop": "Shop", "nav.tomorrow": "What to do tomorrow", "nav.lastminute": "Last Minute",
    "nav.transfers": "Transfers", "nav.eat": "Where to Eat", "nav.guides": "Guides", "nav.partner": "Become a Partner",
    "nav.concierge": "Ask Cristalda", "nav.login": "Sign in", "nav.account": "My account", "nav.admin": "Management",
    "nav.operator": "Operator", "nav.store": "Store Mode", "nav.logout": "Log out",
    "hero.tagline": "Experience Vieste. Discover Gargano.",
    "hero.subtitle": "Discover, compare and book everything to do in Vieste and Gargano in one place.",
    "hero.question": "What do you want to do in Vieste?",
    "search.date": "Date", "search.people": "People", "search.category": "Category", "search.all": "All categories",
    "search.cta": "Discover experiences",
    "home.categories": "What do you want to do?", "home.tomorrow": "What you can do tomorrow in Vieste",
    "home.tomorrow.sub": "Experiences available tomorrow", "home.featured": "Featured experiences",
    "home.lastminute": "Last Minute Vieste", "home.lastminute.sub": "Last spots available, grab them now",
    "home.guides": "Guides & Inspiration",
    "exp.book": "Book now", "exp.from": "from", "exp.perperson": "per person", "exp.perboat": "per boat",
    "exp.pervehicle": "per vehicle", "exp.pergroup": "per group", "exp.fixed": "fixed price", "exp.duration": "Duration",
    "exp.included": "What's included", "exp.excluded": "Not included", "exp.meeting": "Meeting point",
    "exp.cancellation": "Cancellation policy", "exp.weather": "Weather policy", "exp.reviews": "Reviews",
    "exp.related": "You might also like", "exp.operator": "Operator", "exp.selectdate": "Select date",
    "exp.selecttime": "Select time", "exp.participants": "Participants", "exp.available": "Available",
    "exp.few": "Few spots", "exp.full": "Sold out", "exp.addcart": "Add to your holiday",
    "cart.title": "Your holiday in Vieste", "cart.empty": "Your holiday is empty. Add experiences!",
    "cart.total": "Total", "cart.checkout": "Go to checkout", "cart.remove": "Remove",
    "checkout.title": "Complete your booking", "checkout.details": "Your details", "checkout.name": "First name",
    "checkout.surname": "Last name", "checkout.email": "Email", "checkout.phone": "Phone", "checkout.country": "Country",
    "checkout.consent": "I agree to receive marketing communications", "checkout.pay": "Go to payment",
    "checkout.payment": "Payment method", "checkout.mock": "Secure card payment",
    "voucher.title": "Booking confirmed!", "voucher.number": "Booking number", "voucher.download": "Download voucher",
    "common.loading": "Loading...", "common.sponsored": "Sponsored", "common.new": "New", "common.viewall": "View all",
    "common.back": "Back", "concierge.title": "Ask Cristalda", "concierge.sub": "Your AI concierge for a tailor-made itinerary",
    "concierge.placeholder": "E.g: We are a family of 4 with kids aged 6 and 10, staying 3 days. What should we do?",
    "concierge.ask": "Create my itinerary", "whatsapp.help": "Need help? Message us.",
    "common.results": "results", "common.participants": "participants",
    "exp.list.eyebrow": "Experiences in Vieste", "exp.list.all": "All experiences",
    "exp.none": "No experiences found.", "exp.viewall": "View all experiences",
    "sort.recommended": "Recommended", "sort.rating": "Top rated",
    "sort.priceasc": "Price: low to high", "sort.pricedesc": "Price: high to low",
    "exp.maxparticipants": "Max participants", "exp.minage": "Minimum age", "exp.years": "years",
    "toast.selectdatetime": "Select date and time", "toast.added": "Added to your Vieste holiday!",
    "exp.prelaunchdefault": "Bookings coming soon",
    "cart.builder": "Vacation Builder", "cart.addanother": "Add another experience",
    "cart.summary": "Summary", "cart.experiences": "Experiences", "cart.days": "Days",
    "checkout.yourholiday": "Your holiday",
    "checkout.norealpayment": "You will be redirected to secure payment",
    "checkout.gdpr": "Your data is processed according to GDPR principles.",
    "checkout.bookingerror": "Error during booking",
    "payment.processing": "Verifying your payment...",
    "payment.wait": "Please wait a moment, do not close this page.",
    "payment.success": "Payment successful!",
    "payment.successdesc": "Preparing your voucher...",
    "payment.cancelled": "Payment cancelled",
    "payment.cancelleddesc": "No charge was made. Your selection is still in the cart.",
    "payment.backtocart": "Back to cart",
    "payment.failed": "Payment failed",
    "payment.faileddesc": "We couldn't confirm your payment. Please try again or contact us.",
    "payment.retry": "Try again",
    "voucher.showqr": "Show this QR at the meeting point",
    "footer.legal": "Legal", "footer.terms": "Terms & Conditions", "footer.guidesblog": "Guides & Blog", "footer.marketplace": "Tourism marketplace",
    "exp.lastspot": "Last spot available", "exp.spotsleftpre": "Only", "exp.spotsleftpost": "spots left", "toast.availchanged": "Availability changed, please try again.", "common.error": "Something went wrong. Please try again.",
  },
  de: {
    "nav.experiences": "Erlebnisse", "nav.shop": "Shop", "nav.tomorrow": "Morgen erleben", "nav.lastminute": "Last Minute",
    "nav.transfers": "Transfer", "nav.eat": "Essen", "nav.guides": "Guides", "nav.partner": "Partner werden",
    "nav.concierge": "Frag Cristalda", "nav.login": "Anmelden", "nav.account": "Mein Konto", "nav.admin": "Verwaltung",
    "nav.operator": "Betreiber", "nav.store": "Store-Modus", "nav.logout": "Abmelden",
    "hero.tagline": "Erlebe Vieste. Entdecke den Gargano.",
    "hero.subtitle": "Entdecke, vergleiche und buche alles in Vieste und im Gargano an einem Ort.",
    "hero.question": "Was möchtest du in Vieste unternehmen?",
    "search.date": "Datum", "search.people": "Personen", "search.category": "Kategorie", "search.all": "Alle Kategorien",
    "search.cta": "Erlebnisse entdecken",
    "home.categories": "Was möchtest du tun?", "home.tomorrow": "Was du morgen in Vieste erleben kannst",
    "home.tomorrow.sub": "Morgen verfügbare Erlebnisse", "home.featured": "Empfohlene Erlebnisse",
    "home.lastminute": "Last Minute Vieste", "home.lastminute.sub": "Letzte Plätze verfügbar",
    "home.guides": "Guides & Inspiration",
    "exp.book": "Jetzt buchen", "exp.from": "ab", "exp.perperson": "pro Person", "exp.perboat": "pro Boot",
    "exp.pervehicle": "pro Fahrzeug", "exp.pergroup": "pro Gruppe", "exp.fixed": "Festpreis", "exp.duration": "Dauer",
    "exp.included": "Inklusive", "exp.excluded": "Nicht inklusive", "exp.meeting": "Treffpunkt",
    "exp.cancellation": "Stornierung", "exp.weather": "Wetter-Richtlinie", "exp.reviews": "Bewertungen",
    "exp.related": "Das könnte dir gefallen", "exp.operator": "Betreiber", "exp.selectdate": "Datum wählen",
    "exp.selecttime": "Uhrzeit wählen", "exp.participants": "Teilnehmer", "exp.available": "Verfügbar",
    "exp.few": "Wenige Plätze", "exp.full": "Ausverkauft", "exp.addcart": "Zum Urlaub hinzufügen",
    "cart.title": "Dein Urlaub in Vieste", "cart.empty": "Dein Urlaub ist leer. Füge Erlebnisse hinzu!",
    "cart.total": "Gesamt", "cart.checkout": "Zur Kasse", "cart.remove": "Entfernen",
    "checkout.title": "Buchung abschließen", "checkout.details": "Deine Daten", "checkout.name": "Vorname",
    "checkout.surname": "Nachname", "checkout.email": "E-Mail", "checkout.phone": "Telefon", "checkout.country": "Land",
    "checkout.consent": "Ich stimme Marketing-Mitteilungen zu", "checkout.pay": "Zur Zahlung",
    "checkout.payment": "Zahlungsmethode", "checkout.mock": "Sichere Kartenzahlung",
    "voucher.title": "Buchung bestätigt!", "voucher.number": "Buchungsnummer", "voucher.download": "Voucher herunterladen",
    "common.loading": "Laden...", "common.sponsored": "Gesponsert", "common.new": "Neu", "common.viewall": "Alle ansehen",
    "common.back": "Zurück", "concierge.title": "Frag Cristalda", "concierge.sub": "Dein KI-Concierge für eine maßgeschneiderte Reiseroute",
    "concierge.placeholder": "Z.B: Wir sind eine 4-köpfige Familie mit Kindern (6 und 10), 3 Tage. Was tun?",
    "concierge.ask": "Reiseroute erstellen", "whatsapp.help": "Brauchst du Hilfe? Schreib uns.",
    "common.results": "Ergebnisse", "common.participants": "Teilnehmer",
    "exp.list.eyebrow": "Erlebnisse in Vieste", "exp.list.all": "Alle Erlebnisse",
    "exp.none": "Keine Erlebnisse gefunden.", "exp.viewall": "Alle Erlebnisse ansehen",
    "sort.recommended": "Empfohlen", "sort.rating": "Top-Bewertungen",
    "sort.priceasc": "Preis aufsteigend", "sort.pricedesc": "Preis absteigend",
    "exp.maxparticipants": "Max. Teilnehmer", "exp.minage": "Mindestalter", "exp.years": "Jahre",
    "toast.selectdatetime": "Datum und Uhrzeit wählen", "toast.added": "Zu deinem Vieste-Urlaub hinzugefügt!",
    "exp.prelaunchdefault": "Buchungen bald verfügbar",
    "cart.builder": "Vacation Builder", "cart.addanother": "Weiteres Erlebnis hinzufügen",
    "cart.summary": "Übersicht", "cart.experiences": "Erlebnisse", "cart.days": "Tage",
    "checkout.yourholiday": "Dein Urlaub",
    "checkout.norealpayment": "Du wirst zur sicheren Zahlung weitergeleitet",
    "checkout.gdpr": "Deine Daten werden gemäß DSGVO verarbeitet.",
    "checkout.bookingerror": "Fehler bei der Buchung",
    "payment.processing": "Zahlung wird überprüft...",
    "payment.wait": "Bitte warte einen Moment, schließe diese Seite nicht.",
    "payment.success": "Zahlung erfolgreich!",
    "payment.successdesc": "Dein Voucher wird vorbereitet...",
    "payment.cancelled": "Zahlung abgebrochen",
    "payment.cancelleddesc": "Es wurde nichts belastet. Deine Auswahl ist noch im Warenkorb.",
    "payment.backtocart": "Zurück zum Warenkorb",
    "payment.failed": "Zahlung fehlgeschlagen",
    "payment.faileddesc": "Die Zahlung konnte nicht bestätigt werden. Bitte versuche es erneut.",
    "payment.retry": "Erneut versuchen",
    "voucher.showqr": "Zeige diesen QR-Code am Treffpunkt",
    "footer.legal": "Rechtliches", "footer.terms": "AGB", "footer.guidesblog": "Guides & Blog", "footer.marketplace": "Tourismus-Marktplatz",
    "exp.lastspot": "Letzter freier Platz", "exp.spotsleftpre": "Nur noch", "exp.spotsleftpost": "Plätze frei", "toast.availchanged": "Verfügbarkeit geändert, bitte erneut versuchen.", "common.error": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  },
  fr: {
    "nav.experiences": "Expériences", "nav.shop": "Shop", "nav.tomorrow": "Que faire demain", "nav.lastminute": "Dernière minute",
    "nav.transfers": "Transferts", "nav.eat": "Où manger", "nav.guides": "Guides", "nav.partner": "Devenir partenaire",
    "nav.concierge": "Demandez à Cristalda", "nav.login": "Connexion", "nav.account": "Mon compte", "nav.admin": "Gestion",
    "nav.operator": "Opérateur", "nav.store": "Mode boutique", "nav.logout": "Déconnexion",
    "hero.tagline": "Vivez Vieste. Découvrez le Gargano.",
    "hero.subtitle": "Découvrez, comparez et réservez toutes les expériences de Vieste et du Gargano en un seul endroit.",
    "hero.question": "Que voulez-vous faire à Vieste ?",
    "search.date": "Date", "search.people": "Personnes", "search.category": "Catégorie", "search.all": "Toutes les catégories",
    "search.cta": "Découvrir les expériences",
    "home.categories": "Que voulez-vous faire ?", "home.tomorrow": "Ce que vous pouvez faire demain à Vieste",
    "home.tomorrow.sub": "Expériences disponibles demain", "home.featured": "Expériences en vedette",
    "home.lastminute": "Dernière minute Vieste", "home.lastminute.sub": "Dernières places disponibles",
    "home.guides": "Guides & Inspiration",
    "exp.book": "Réserver", "exp.from": "à partir de", "exp.perperson": "par personne", "exp.perboat": "par bateau",
    "exp.pervehicle": "par véhicule", "exp.pergroup": "par groupe", "exp.fixed": "prix fixe", "exp.duration": "Durée",
    "exp.included": "Inclus", "exp.excluded": "Non inclus", "exp.meeting": "Point de rencontre",
    "exp.cancellation": "Politique d'annulation", "exp.weather": "Politique météo", "exp.reviews": "Avis",
    "exp.related": "Cela pourrait vous plaire", "exp.operator": "Opérateur", "exp.selectdate": "Choisir la date",
    "exp.selecttime": "Choisir l'heure", "exp.participants": "Participants", "exp.available": "Disponible",
    "exp.few": "Dernières places", "exp.full": "Complet", "exp.addcart": "Ajouter à mes vacances",
    "cart.title": "Vos vacances à Vieste", "cart.empty": "Vos vacances sont vides. Ajoutez des expériences !",
    "cart.total": "Total", "cart.checkout": "Passer au paiement", "cart.remove": "Retirer",
    "checkout.title": "Finaliser la réservation", "checkout.details": "Vos coordonnées", "checkout.name": "Prénom",
    "checkout.surname": "Nom", "checkout.email": "E-mail", "checkout.phone": "Téléphone", "checkout.country": "Pays",
    "checkout.consent": "J'accepte de recevoir des communications marketing", "checkout.pay": "Aller au paiement",
    "checkout.payment": "Mode de paiement", "checkout.mock": "Paiement sécurisé par carte",
    "voucher.title": "Réservation confirmée !", "voucher.number": "Numéro de réservation", "voucher.download": "Télécharger le bon",
    "common.loading": "Chargement...", "common.sponsored": "Sponsorisé", "common.new": "Nouveau", "common.viewall": "Voir tout",
    "common.back": "Retour", "concierge.title": "Demandez à Cristalda", "concierge.sub": "Votre concierge IA pour un itinéraire sur mesure",
    "concierge.placeholder": "Ex : Nous sommes une famille de 4 avec des enfants de 6 et 10 ans, 3 jours. Que faire ?",
    "concierge.ask": "Créer mon itinéraire", "whatsapp.help": "Besoin d'aide ? Écrivez-nous.",
    "common.results": "résultats", "common.participants": "participants",
    "exp.list.eyebrow": "Expériences à Vieste", "exp.list.all": "Toutes les expériences",
    "exp.none": "Aucune expérience trouvée.", "exp.viewall": "Voir toutes les expériences",
    "sort.recommended": "Recommandés", "sort.rating": "Mieux notés",
    "sort.priceasc": "Prix croissant", "sort.pricedesc": "Prix décroissant",
    "exp.maxparticipants": "Participants max", "exp.minage": "Âge minimum", "exp.years": "ans",
    "toast.selectdatetime": "Sélectionnez la date et l'heure", "toast.added": "Ajouté à vos vacances à Vieste !",
    "exp.prelaunchdefault": "Réservations bientôt disponibles",
    "cart.builder": "Vacation Builder", "cart.addanother": "Ajouter une autre expérience",
    "cart.summary": "Récapitulatif", "cart.experiences": "Expériences", "cart.days": "Jours",
    "checkout.yourholiday": "Vos vacances",
    "checkout.norealpayment": "Vous serez redirigé vers le paiement sécurisé",
    "checkout.gdpr": "Vos données sont traitées conformément au RGPD.",
    "checkout.bookingerror": "Erreur lors de la réservation",
    "payment.processing": "Vérification du paiement...",
    "payment.wait": "Patientez un instant, ne fermez pas cette page.",
    "payment.success": "Paiement réussi !",
    "payment.successdesc": "Préparation de votre voucher...",
    "payment.cancelled": "Paiement annulé",
    "payment.cancelleddesc": "Aucun débit n'a été effectué. Votre sélection est toujours dans le panier.",
    "payment.backtocart": "Retour au panier",
    "payment.failed": "Paiement échoué",
    "payment.faileddesc": "Nous n'avons pas pu confirmer le paiement. Réessayez ou contactez-nous.",
    "payment.retry": "Réessayer",
    "voucher.showqr": "Montrez ce QR au point de rencontre",
    "footer.legal": "Mentions légales", "footer.terms": "Conditions générales", "footer.guidesblog": "Guides & Blog", "footer.marketplace": "Marketplace touristique",
    "exp.lastspot": "Dernière place disponible", "exp.spotsleftpre": "Plus que", "exp.spotsleftpost": "places disponibles", "toast.availchanged": "Disponibilité modifiée, réessayez.", "common.error": "Une erreur s'est produite. Réessayez.",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("cristalda_lang") || "it");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("cristalda_lang", l);
  }, []);
  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.it[key] ?? key,
    [lang]
  );
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
export const LANGS = [{ code: "it", label: "IT" }, { code: "en", label: "EN" }, { code: "de", label: "DE" }, { code: "fr", label: "FR" }];
